import { default as indexIDgIufCyYWMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/[slug]/index.vue?macro=true";
import { default as _404Qo2ywGe9wJMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/404.vue?macro=true";
import { default as bet_45history4XClC8JL8bMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/account/bet-history.vue?macro=true";
import { default as indexdH1gtktM5YMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/account/index.vue?macro=true";
import { default as informationSk2hlQmHOmMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/account/information.vue?macro=true";
import { default as my_45promotion4zRARzWrNEMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/account/my-promotion.vue?macro=true";
import { default as passwordvplncexyOgMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/account/password.vue?macro=true";
import { default as transaction_45historylMVi1XIsIkMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/account/transaction-history.vue?macro=true";
import { default as user_45bankCX7TPCivjxMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/account/user-bank.vue?macro=true";
import { default as chinh_45sach_45bao_45matuHhhcsz8scMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/chinh-sach-bao-mat.vue?macro=true";
import { default as choi_45gan_45dayeLfcElk7LqMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/choi-gan-day.vue?macro=true";
import { default as cuoc_45hop_45phapGQoOWt3SFnMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/cuoc-hop-phap.vue?macro=true";
import { default as dieu_45khoan_45dieu_45kienKysZpP4NizMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/dieu-khoan-dieu-kien.vue?macro=true";
import { default as index98OWpxpevSMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/index.vue?macro=true";
import { default as hoan_45tra_45vo_45tanTss4il14sdMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/khuyen-mai/hoan-tra-vo-tan.vue?macro=true";
import { default as indexBqsYtQQx6sMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/khuyen-mai/index.vue?macro=true";
import { default as khai_45truong_45hong_45phatYJkvAvMaBwMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/khuyen-mai/khai-truong-hong-phat.vue?macro=true";
import { default as thuong_45nap_45lan_45dautjX09c2YlQMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/khuyen-mai/thuong-nap-lan-dau.vue?macro=true";
import { default as thuong_45nap_45lan_45haipE4MpstPweMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/khuyen-mai/thuong-nap-lan-hai.vue?macro=true";
import { default as lien_45heOhSRGDubgwMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/lien-he.vue?macro=true";
import { default as _91cats_93rkIuhdGeCXMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/live-casino/[prov]/[cats].vue?macro=true";
import { default as indexXqravBL1WhMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/live-casino/[prov]/index.vue?macro=true";
import { default as index145lFl6d8QMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/live-casino/index.vue?macro=true";
import { default as maintenancemEL1dKqMBrMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/maintenance.vue?macro=true";
import { default as index0BIX47JD3CMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/nap-tien/index.vue?macro=true";
import { default as indexQs5ZwWuzrtMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/rut-tien/index.vue?macro=true";
import { default as searchArssp5JBXiMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/search.vue?macro=true";
import { default as indexYrV8Jozu2gMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/su-kien-rut-tham/index.vue?macro=true";
import { default as term_45and_45condition3VyYUTnYSNMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/term-and-condition.vue?macro=true";
import { default as the_45thaoHCPzbBB4T7Meta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/the-thao.vue?macro=true";
import { default as _91cat_93qBPJMjN5ZUMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/tin-tuc/[cat].vue?macro=true";
import { default as indexkCP8bD795gMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/tin-tuc/index.vue?macro=true";
import { default as indexYqnrqd7T2CMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/transaction-coin12/index.vue?macro=true";
import { default as transactionzxeC3UAX0rMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/transaction.vue?macro=true";
import { default as _91prov_93SXSRHi8de6Meta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/tro-choi/[cats]/[prov].vue?macro=true";
import { default as index5FUrywEZhpMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/tro-choi/[cats]/index.vue?macro=true";
import { default as indexkTAgYLD71NMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/tro-choi/index.vue?macro=true";
import { default as ve_45chung_45toi8bZkHeGKKQMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/ve-chung-toi.vue?macro=true";
import { default as yeu_45thich4v6Dvi1yXbMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/yeu-thich.vue?macro=true";
import { default as component_45stubj0zGtm3NHHMeta } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubj0zGtm3NHH } from "/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "slug",
    path: "/:slug()",
    meta: indexIDgIufCyYWMeta || {},
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "404",
    path: "/404",
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/404.vue").then(m => m.default || m)
  },
  {
    name: "account-bet-history",
    path: "/account/bet-history",
    meta: bet_45history4XClC8JL8bMeta || {},
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/account/bet-history.vue").then(m => m.default || m)
  },
  {
    name: "account",
    path: "/account",
    meta: indexdH1gtktM5YMeta || {},
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: "account-information",
    path: "/account/information",
    meta: informationSk2hlQmHOmMeta || {},
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/account/information.vue").then(m => m.default || m)
  },
  {
    name: "account-my-promotion",
    path: "/account/my-promotion",
    meta: my_45promotion4zRARzWrNEMeta || {},
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/account/my-promotion.vue").then(m => m.default || m)
  },
  {
    name: "account-password",
    path: "/account/password",
    meta: passwordvplncexyOgMeta || {},
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/account/password.vue").then(m => m.default || m)
  },
  {
    name: "account-transaction-history",
    path: "/account/transaction-history",
    meta: transaction_45historylMVi1XIsIkMeta || {},
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/account/transaction-history.vue").then(m => m.default || m)
  },
  {
    name: "account-user-bank",
    path: "/account/user-bank",
    meta: user_45bankCX7TPCivjxMeta || {},
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/account/user-bank.vue").then(m => m.default || m)
  },
  {
    name: "chinh-sach-bao-mat",
    path: "/chinh-sach-bao-mat",
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/chinh-sach-bao-mat.vue").then(m => m.default || m)
  },
  {
    name: "choi-gan-day",
    path: "/choi-gan-day",
    meta: choi_45gan_45dayeLfcElk7LqMeta || {},
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/choi-gan-day.vue").then(m => m.default || m)
  },
  {
    name: "cuoc-hop-phap",
    path: "/cuoc-hop-phap",
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/cuoc-hop-phap.vue").then(m => m.default || m)
  },
  {
    name: "dieu-khoan-dieu-kien",
    path: "/dieu-khoan-dieu-kien",
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/dieu-khoan-dieu-kien.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    meta: index98OWpxpevSMeta || {},
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "khuyen-mai-hoan-tra-vo-tan",
    path: "/khuyen-mai/hoan-tra-vo-tan",
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/khuyen-mai/hoan-tra-vo-tan.vue").then(m => m.default || m)
  },
  {
    name: "khuyen-mai",
    path: "/khuyen-mai",
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/khuyen-mai/index.vue").then(m => m.default || m)
  },
  {
    name: "khuyen-mai-khai-truong-hong-phat",
    path: "/khuyen-mai/khai-truong-hong-phat",
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/khuyen-mai/khai-truong-hong-phat.vue").then(m => m.default || m)
  },
  {
    name: "khuyen-mai-thuong-nap-lan-dau",
    path: "/khuyen-mai/thuong-nap-lan-dau",
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/khuyen-mai/thuong-nap-lan-dau.vue").then(m => m.default || m)
  },
  {
    name: "khuyen-mai-thuong-nap-lan-hai",
    path: "/khuyen-mai/thuong-nap-lan-hai",
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/khuyen-mai/thuong-nap-lan-hai.vue").then(m => m.default || m)
  },
  {
    name: "lien-he",
    path: "/lien-he",
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/lien-he.vue").then(m => m.default || m)
  },
  {
    name: "live-casino-prov-cats",
    path: "/live-casino/:prov()/:cats()",
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/live-casino/[prov]/[cats].vue").then(m => m.default || m)
  },
  {
    name: "live-casino-prov",
    path: "/live-casino/:prov()",
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/live-casino/[prov]/index.vue").then(m => m.default || m)
  },
  {
    name: "live-casino",
    path: "/live-casino",
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/live-casino/index.vue").then(m => m.default || m)
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/maintenance.vue").then(m => m.default || m)
  },
  {
    name: "nap-tien",
    path: "/nap-tien",
    meta: index0BIX47JD3CMeta || {},
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/nap-tien/index.vue").then(m => m.default || m)
  },
  {
    name: "rut-tien",
    path: "/rut-tien",
    meta: indexQs5ZwWuzrtMeta || {},
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/rut-tien/index.vue").then(m => m.default || m)
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/search.vue").then(m => m.default || m)
  },
  {
    name: "su-kien-rut-tham",
    path: "/su-kien-rut-tham",
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/su-kien-rut-tham/index.vue").then(m => m.default || m)
  },
  {
    name: "term-and-condition",
    path: "/term-and-condition",
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/term-and-condition.vue").then(m => m.default || m)
  },
  {
    name: "the-thao",
    path: "/the-thao",
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/the-thao.vue").then(m => m.default || m)
  },
  {
    name: "tin-tuc-cat",
    path: "/tin-tuc/:cat()",
    meta: _91cat_93qBPJMjN5ZUMeta || {},
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/tin-tuc/[cat].vue").then(m => m.default || m)
  },
  {
    name: "tin-tuc",
    path: "/tin-tuc",
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/tin-tuc/index.vue").then(m => m.default || m)
  },
  {
    name: "transaction-coin12",
    path: "/transaction-coin12",
    meta: indexYqnrqd7T2CMeta || {},
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/transaction-coin12/index.vue").then(m => m.default || m)
  },
  {
    name: "transaction",
    path: "/transaction",
    meta: transactionzxeC3UAX0rMeta || {},
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/transaction.vue").then(m => m.default || m)
  },
  {
    name: "tro-choi-cats-prov",
    path: "/tro-choi/:cats()/:prov()",
    meta: _91prov_93SXSRHi8de6Meta || {},
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/tro-choi/[cats]/[prov].vue").then(m => m.default || m)
  },
  {
    name: "tro-choi-cats",
    path: "/tro-choi/:cats()",
    meta: index5FUrywEZhpMeta || {},
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/tro-choi/[cats]/index.vue").then(m => m.default || m)
  },
  {
    name: "tro-choi",
    path: "/tro-choi",
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/tro-choi/index.vue").then(m => m.default || m)
  },
  {
    name: "ve-chung-toi",
    path: "/ve-chung-toi",
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/ve-chung-toi.vue").then(m => m.default || m)
  },
  {
    name: "yeu-thich",
    path: "/yeu-thich",
    meta: yeu_45thich4v6Dvi1yXbMeta || {},
    component: () => import("/home/msservice/workspace/86BET/PROD/PROD-86BET-FE/86bet-fe-prod/pages/yeu-thich.vue").then(m => m.default || m)
  },
  {
    name: component_45stubj0zGtm3NHHMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubj0zGtm3NHH
  },
  {
    name: component_45stubj0zGtm3NHHMeta?.name,
    path: "/general-sitemap.xml",
    component: component_45stubj0zGtm3NHH
  },
  {
    name: component_45stubj0zGtm3NHHMeta?.name,
    path: "/promotions-sitemap.xml",
    component: component_45stubj0zGtm3NHH
  },
  {
    name: component_45stubj0zGtm3NHHMeta?.name,
    path: "/categories-sitemap.xml",
    component: component_45stubj0zGtm3NHH
  },
  {
    name: component_45stubj0zGtm3NHHMeta?.name,
    path: "/news-sitemap.xml",
    component: component_45stubj0zGtm3NHH
  }
]